module.exports = __webpack_public_path__ + "img/6.0c9c3d1a.jpg";